/* eslint-disable @typescript-eslint/naming-convention */
import { InjectionToken, Type } from '@angular/core';

export const PlatformDynamicComponentsToken = new InjectionToken<{
  [type: string]: Type<unknown>;
}>('PlatformDynamicComponentsToken');

export const PlatformDynamicComponentsPreviewToken = new InjectionToken<{
  [type: string]: Type<unknown>;
}>('PlatformDynamicComponentsPreviewToken');
